/**
 * Generated by orval v6.24.0 🍺
 * Do not edit manually.
 * Payse API
 * How to use payse API
 * OpenAPI spec version: 3.0.1
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import type {
  GetProductCaution200,
  ListProductCautions200,
  ListProductCautionsParams,
} from ".././schemas";
import { customAxiosInstance } from "../../../configs/customAxiosInstance";
import type { ErrorType } from "../../../configs/customAxiosInstance";
import { customFormUrlEncodedFn } from "../../../configs/formUrlEncoded";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * 現在アクティブな商品注意事項の一覧を返します。product_variant_idで絞り込み可能です。
 * @summary 商品注意事項の一覧を取得
 */
export const listProductCautions = (
  params?: ListProductCautionsParams,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal
) => {
  return customAxiosInstance<ListProductCautions200>(
    { url: `/product_cautions`, method: "GET", params, signal },
    options
  );
};

export const getListProductCautionsQueryKey = (params?: ListProductCautionsParams) => {
  return [`/product_cautions`, ...(params ? [params] : [])] as const;
};

export const getListProductCautionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listProductCautions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProductCautionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listProductCautions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProductCautionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductCautions>>> = ({ signal }) =>
    listProductCautions(params, requestOptions, signal);

  return { queryKey, queryFn, staleTime: 30000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProductCautions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListProductCautionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProductCautions>>
>;
export type ListProductCautionsQueryError = ErrorType<unknown>;

/**
 * @summary 商品注意事項の一覧を取得
 */
export const useListProductCautions = <
  TData = Awaited<ReturnType<typeof listProductCautions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProductCautionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listProductCautions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListProductCautionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary 商品注意事項の一覧を取得
 */
export const prefetchListProductCautions = async <
  TData = Awaited<ReturnType<typeof listProductCautions>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  params?: ListProductCautionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listProductCautions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getListProductCautionsQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getListProductCautionsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listProductCautions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProductCautionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductCautions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProductCautionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductCautions>>> = ({ signal }) =>
    listProductCautions(params, requestOptions, signal);

  return { queryKey, queryFn, staleTime: 30000, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listProductCautions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListProductCautionsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProductCautions>>
>;
export type ListProductCautionsSuspenseQueryError = ErrorType<unknown>;

/**
 * @summary 商品注意事項の一覧を取得
 */
export const useListProductCautionsSuspense = <
  TData = Awaited<ReturnType<typeof listProductCautions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProductCautionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductCautions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListProductCautionsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary 商品注意事項の一覧を取得
 */
export const prefetchListProductCautionsSuspense = async <
  TData = Awaited<ReturnType<typeof listProductCautions>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  params?: ListProductCautionsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listProductCautions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getListProductCautionsSuspenseQueryOptions(params, options);

  await queryClient.prefetchSuspenseQuery(queryOptions);

  return queryClient;
};

/**
 * 指定されたIDの商品注意事項を取得します
 * @summary 特定の商品注意事項を取得
 */
export const getProductCaution = (
  id: string,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal
) => {
  return customAxiosInstance<GetProductCaution200>(
    { url: `/product_cautions/${id}`, method: "GET", signal },
    options
  );
};

export const getGetProductCautionQueryKey = (id: string) => {
  return [`/product_cautions/${id}`] as const;
};

export const getGetProductCautionQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductCaution>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCaution>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductCautionQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductCaution>>> = ({ signal }) =>
    getProductCaution(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, staleTime: 30000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductCaution>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProductCautionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductCaution>>
>;
export type GetProductCautionQueryError = ErrorType<void>;

/**
 * @summary 特定の商品注意事項を取得
 */
export const useGetProductCaution = <
  TData = Awaited<ReturnType<typeof getProductCaution>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCaution>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetProductCautionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary 特定の商品注意事項を取得
 */
export const prefetchGetProductCaution = async <
  TData = Awaited<ReturnType<typeof getProductCaution>>,
  TError = ErrorType<void>,
>(
  queryClient: QueryClient,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCaution>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getGetProductCautionQueryOptions(id, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export const getGetProductCautionSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductCaution>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductCaution>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductCautionQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductCaution>>> = ({ signal }) =>
    getProductCaution(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 30000,
    ...queryOptions,
  } as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductCaution>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetProductCautionSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductCaution>>
>;
export type GetProductCautionSuspenseQueryError = ErrorType<void>;

/**
 * @summary 特定の商品注意事項を取得
 */
export const useGetProductCautionSuspense = <
  TData = Awaited<ReturnType<typeof getProductCaution>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductCaution>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetProductCautionSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary 特定の商品注意事項を取得
 */
export const prefetchGetProductCautionSuspense = async <
  TData = Awaited<ReturnType<typeof getProductCaution>>,
  TError = ErrorType<void>,
>(
  queryClient: QueryClient,
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductCaution>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  }
): Promise<QueryClient> => {
  const queryOptions = getGetProductCautionSuspenseQueryOptions(id, options);

  await queryClient.prefetchSuspenseQuery(queryOptions);

  return queryClient;
};
